module.exports = __webpack_public_path__ + "img/step20_b_printer_basic_remove_tapes.ca7de4cb.png";